import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

import { DialogComponent } from '../../../ui/dialog/dialog';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';

@Component({
  selector: 'component-customer-anamnesis',
  templateUrl: './anamnesis.component.html',
  styleUrls: ['./anamnesis.component.scss']
})
export class CustomerAnamnesisComponent implements OnInit, OnDestroy {
  PAGE: any;
  STRINGS: any;

  private studentToken: string | null = null;
  private linkSubscription: Subscription;
  private sessionVersion = 0;
  @Input() anamnesis: any = null;
  @Input() studentData: any = null;
  @Input() admMode: boolean = false;

  @Output() closeAnamnesis = new EventEmitter<void>();
  modernRecord: any = null;
  modernSections: any[] = [];
  loadError = false;
  private requestVersion = 0;

  openModernRecord(record: any) {
    try {
      const answers = typeof record.anamnesis === 'string' ? JSON.parse(record.anamnesis) : record.anamnesis;
      if (!answers || typeof answers !== 'object' || Array.isArray(answers)) throw new Error('Invalid anamnesis');
      const text = (value: any) => value == null || String(value).trim() === '' ? 'Não informado' : String(value);
      const yesNo = (value: any) => value === 's' ? this.STRINGS.msg_sim : value === 'n' ? this.STRINGS.msg_nao : 'Não informado';
      const selected = (value: any) => Array.isArray(value) ? value.filter(item => item && (item.selecionada === true || item.selecionada === 1)).map(item => item.nome).filter(Boolean).join(', ') : '';
      const row = (label: string, value: any) => ({label, value: text(value)});
      this.modernSections = [
        {title: this.PAGE.queixas_atuais, icon: 'healing', rows: [row(this.PAGE.queixas_atuais, selected(answers.complain_ids)), row(this.PAGE.outros, answers.complain_obs)]},
        {title: this.PAGE.doencas_pre, icon: 'medical_services', rows: [row(this.PAGE.doencas_pre, selected(answers.disease_ids)), row(this.PAGE.outros, answers.disease_obs)]},
        {title: this.PAGE.antecedentes_pessoais, icon: 'person_outline', rows: [row(this.PAGE.cirurgias, yesNo(answers.pessoal_cirurgy)), row(this.PAGE.traumas, yesNo(answers.pessoal_trauma)), row(this.PAGE.outros, answers.pessoal_obs)]},
        {title: this.PAGE.antecedentes_familiares, icon: 'people_outline', rows: [row(this.PAGE.colesterol, yesNo(answers.family_colesterol)), row(this.PAGE.doenca_diabetes, yesNo(answers.family_diabetes)), row(this.PAGE.outros, answers.family_obs)]},
        {title: this.PAGE.habitos, icon: 'favorite_border', rows: [row(this.PAGE.etilismo, yesNo(answers.habits_alchool)), row(this.PAGE.tabagismo, yesNo(answers.habits_smoke)), row(this.PAGE.anticoncepcionais, yesNo(answers.habits_acpill)), row(this.PAGE.outros, answers.habits_obs)]},
        {title: this.PAGE.historico_treino, icon: 'fitness_center', rows: [
          row(this.PAGE.quanto_tempo_treino, answers.treino_tempo), row(this.PAGE.quantas_vezes_treina, selected(answers.treino_freq)),
          row('Período de treino', ({1: this.PAGE.periodo_manha, 2: this.PAGE.periodo_tarde, 3: this.PAGE.periodo_noite})[answers.treino_periodo]),
          row(this.PAGE.periodo_possivel, answers.treino_tempo_extra), row(this.PAGE.treino_gosta, selected(answers.treino_favs)),
          row(this.PAGE.sobre_treino_anterior, answers.treino_obs_extra),
          row(this.PAGE.data_inicio, this.formatModernDate(answers.treino_inicio)), row(this.PAGE.complemento_anamnese, answers.observacoes)
        ]}
      ];
      this.modernRecord = record;
    } catch (error) {
      this.toastr.error('Não foi possível abrir esta anamnese.', '', this.helpers.toastrCfgs);
    }
  }

  formatModernDate(value: any): string {
    if (!value) return '';
    const day = String(value).slice(0, 10);
    const date = new Date(day + 'T12:00:00');
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString(this.STRINGS.lang === 'en' ? 'en-US' : this.STRINGS.lang === 'es' ? 'es-ES' : 'pt-BR');
  }

  loading: boolean = false;
  callLogin: boolean = true;
  done: boolean = false;
  showForm: boolean = false;

  teacherCode: string = '';
  studentEmail: string = '';
  anamnesisLink: string = '';
  language: string = '';
  teacher = { id: 0, name: 'Professor', avatar: null, link: '' };
  user: any = null;
  anamnesisList: any = null;
  anamnesisCreatedAt: any = null;
  anamnesisId: number = 0;

  studentSelected: boolean = false;
  studentId: number = 0;

  queixas = [];
  doencas = [];
  frequencia = [];
  favoritos = [];

  anamneseForm = new FormGroup({
    id: new FormControl(''),
    complain_ids: new FormControl(''),
    complain_obs: new FormControl(''),
    disease_ids: new FormControl(''),
    disease_obs: new FormControl(''),
    pessoal_cirurgy: new FormControl(''),
    pessoal_trauma: new FormControl(''),
    pessoal_obs: new FormControl(''),
    family_colesterol: new FormControl(''),
    family_diabetes: new FormControl(''),
    family_obs: new FormControl(''),
    habits_alchool: new FormControl(''),
    habits_smoke: new FormControl(''),
    habits_acpill: new FormControl(''),
    habits_obs: new FormControl(''),
    treino_tempo: new FormControl(''),
    treino_freq: new FormControl(''),
    treino_periodo: new FormControl(''),
    treino_tempo_extra: new FormControl(''),
    treino_favs: new FormControl(''),
    treino_inicio: new FormControl(''),
    treino_obs_extra: new FormControl(''),
    observacoes: new FormControl(''),
  });

  passwordForm = new FormGroup({
    password: new FormControl(''),
  });

  studentDateStart: any;

  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
  ) {
    const qs = this.helpers.getUrlParam();
    if (qs.l !== null) this.helpers.changeLang(qs.l);


    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerAnamnesisComponent');

    // this.teacherCode = this.route.snapshot.params.code;

    this.linkSubscription = this.route.queryParams.subscribe(
      (params: any) => {
        // Defaults to 0 if no query param provided.
        const teacherCode = params['professor'] || '';
        const studentEmail = params['aluno'] || '';
        if (teacherCode !== this.teacherCode || studentEmail !== this.studentEmail) {
          this.sessionVersion++;
          this.loading = false;
          this.studentToken = null;
          this.user = null;
          this.done = false;
          this.callLogin = true;
          this.passwordForm.reset();
        }
        this.teacherCode = teacherCode;
        this.studentEmail = studentEmail;
      }
    );

    this.setTranslations();
  }
  ngOnInit() {
    console.log('anamnesis ok');

    this.anamneseForm.reset();
    this.studentSelected = false;
    this.studentId = 0;

    if (this.admMode === false) {
      // se admMode for falso, quer dizer que e o aluno preenchendo a anamnese
      this.showForm = true;
      this.getTeacherGreeting();

    }
  }

  ngOnDestroy() {
    this.sessionVersion++;
    this.studentToken = null;
    this.passwordForm.reset();
    if (this.linkSubscription) this.linkSubscription.unsubscribe();
  }

  ngOnChanges() {
    if (!this.admMode || !this.studentData) return;
    this.done = false;
    this.callLogin = false;
    this.showForm = false;
    this.modernRecord = null;
    this.modernSections = [];
    this.teacher = this.auth.retrieveLocalUser();
    this.anamnesisLink = window.location.origin + '?p=' + encodeURIComponent(this.teacher.link) + '&s=' + encodeURIComponent(this.studentData.email) + '&l=' + this.STRINGS.lang;
    this.getStudentAnamnesis();
  }

  getTeacherGreeting() {
    this.loading = true;
    // busca o avatar e saudacao do professor
    this.userProv.getTeacherGreeting(this.teacherCode, null).then(
      (res: any) => {
        this.loading = false;
        this.teacher = res.teacher;
        if (this.user === null) this.callLogin = true;
      },
      (err: any) => {
        console.log(err);
        this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.teacher = null;
        this.loading = false;
      }
    );
  }

  async getStudentAnamnesis() {
    if (!this.admMode || !this.studentData || !this.studentData.id) return;
    const version = ++this.requestVersion;
    this.loading = true;
    this.loadError = false;
    this.anamnesisList = [];
    try {
      const res: any = await this.studentProv.getAnamnesis(this.studentData.id);
      if (version !== this.requestVersion) return;
      this.anamnesisList = (res.anamns || []).slice().sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
    } catch (error) {
      if (version !== this.requestVersion) return;
      this.loadError = true;
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
    } finally {
      if (version === this.requestVersion) this.loading = false;
    }
  }

  selectAnamnesis(data: any = null) {
    this.setTranslations();
    this.showForm = true;
    this.patchAnamnesis(data.anamnesis);
    this.anamnesisId = data.id;
    this.anamnesisCreatedAt = data.created_at;
  }

  backAnamnesis() {
    this.modernRecord = null;
    this.modernSections = [];
    this.anamneseForm.reset();
    this.showForm = false;
  }

  patchAnamnesis(data: string = '') {
    const anamnesis = JSON.parse(data);
    // console.log(anamnesis);
    this.anamneseForm.patchValue(anamnesis);
    this.queixas = (anamnesis.complain_ids) ? anamnesis.complain_ids : null;
    this.doencas = (anamnesis.disease_ids) ? anamnesis.disease_ids : null;
    this.frequencia = (anamnesis.treino_freq) ? anamnesis.treino_freq : null;
    this.favoritos = (anamnesis.treino_favs) ? anamnesis.treino_favs : null;
    this.favoritos = (anamnesis.treino_favs) ? anamnesis.treino_favs : null;

    this.studentDateStart = new Date(anamnesis.treino_inicio);
    const offsetMs = this.studentDateStart.getTimezoneOffset() * 3 * 60 * 1000;
    this.studentDateStart = new Date(this.studentDateStart.getTime() + offsetMs);
  }


  login() {
    if (!this.admMode && this.user === null && !this.loading) {
      this.loading = true;
      const sessionVersion = this.sessionVersion;
      let email = this.studentEmail;
      let pass = this.passwordForm.value.password;

      // valida o email
      this.studentProv.getCustomerLogin(email, pass, null).then(
        (res: any) => {
          if (sessionVersion !== this.sessionVersion) return;
          // verify if user already fill the anamnesis
          this.loading = false;
          if (!res || !res.user || !res.token) {
            this.toastr.error(this.PAGE.senha_invalida, '', this.helpers.toastrCfgs);
            return;
          }
          this.user = res.user;
          this.studentToken = res.token;
          this.passwordForm.reset();
          this.callLogin = false;
          if (this.user.anamnesis) {
            this.done = true;
          }
          // console.log(this.user);
        },
        (_err: any) => {
          if (sessionVersion !== this.sessionVersion) return;
          this.toastr.error(this.PAGE.senha_invalida, '', this.helpers.toastrCfgs);
          // this.toastr.error(err);
          this.loading = false;
        }
      );
    }
  }

  new() {
    this.anamneseForm.reset();
    this.studentSelected = false;
    this.studentId = 0;
    // this.studentForm.patchValue({ status: 2 });
  }


  save() {
    if (this.admMode || this.loading || !this.studentToken || !this.user || this.callLogin || this.done) return;
    this.validateAllFormFields(this.anamneseForm);

    // if (this.studentForm.value.password !== this.studentForm.value.password_confirmation) {
    //   this.toastr.error('As senhas não conferem!');
    //   return false;
    // }

    const dataString = JSON.stringify(this.anamneseForm.value);
    const data = JSON.parse(dataString);
    if (data.treino_inicio) {
      data.treino_inicio = data.treino_inicio.substring(-10, 10);
    }
    data.customer_id = this.user.id;
    data.user_id = this.teacher.id;
    data.complain_ids = this.queixas;
    data.disease_ids = this.doencas;
    data.treino_freq = this.frequencia;
    data.treino_favs = this.favoritos;

    const anamnesis = {
      id: this.user.id,
      details: {
        anamnesis: JSON.stringify(data)
      }
    }

    // console.log(anamnesis);

    this.loading = true;
    const sessionVersion = this.sessionVersion;
    this.studentProv.sendAnamnesis(anamnesis, this.studentToken).then(
      (_user: any) => {
        if (sessionVersion !== this.sessionVersion) return;
        this.loading = false;
        this.done = true;
        this.studentToken = null;
        this.toastr.success(this.PAGE.anamnese_add_sucesso, '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        if (sessionVersion !== this.sessionVersion) return;
        this.loading = false;
        console.log(err);
        this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
      }
    );

  }

  delete(id: number = 0) {
    const version = this.requestVersion;
    const msg = this.PAGE.anamnese_apagar;
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.anamnese_apagar_title, message: msg, confirmation: 'Sim'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Sim' && version === this.requestVersion) {
        this.loading = true;
        this.studentProv.admDeleteAnamnesis(id).then(
          (res: any) => {
            if (version !== this.requestVersion) return;
            this.loading = false;
            this.anamnesisList = (res.anamns.length > 0) ? res.anamns : null;
            this.toastr.success(this.PAGE.anamnese_apagar_sucesso, '', this.helpers.toastrCfgs);
            this.backAnamnesis();
          },
          (err: any) => {
            if (version !== this.requestVersion) return;
            this.loading = false;
            console.log(err);
            this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);    
          }
        );
      }
    });
  }

  updateAllComplete() {
    //
  }

  getUserFormValidationMessage(el: any) {
    if (el.errors.required) {
      return this.STRINGS.campo_obrigatorio;
    }

    if (el.errors.incorrect || el.errors.pattern) {
      return this.STRINGS.campo_invalido;
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  toggleClass(item: any) {
    item.active = !item.active;
  }

  copyTransfer(url: string = '') {
    if (this.helpers.copyTextToClipboard(url)) {
      console.log('copiou url');
    } else {
      console.log('não copiou url');
    }        


    const navShare: any = window.navigator;
    if (navShare.share !== undefined) {
      // console.log('share ok');
      navShare.share({
        title: 'ST Coach',
        text: this.PAGE.questionario,
        url: url,
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
    } else {
      // console.log('share not ok');
      if (this.helpers.copyTextToClipboard(url)) {
        this.toastr.success(this.STRINGS.link_copiado, '', this.helpers.toastrCfgs);
      } else {
        this.toastr.error(this.STRINGS.link_copiado_erro, '', this.helpers.toastrCfgs);
      }        
    }
  }

  setTranslations() {
    this.queixas = [
      { id: 1, nome: this.PAGE.queixa_dor_cabeca, selecionada: false },
      { id: 2, nome: this.PAGE.queixa_dor_pescoco, selecionada: false },
      { id: 3, nome: this.PAGE.queixa_dor_peito, selecionada: false },
      { id: 4, nome: this.PAGE.queixa_dor_ombros, selecionada: false },
      { id: 5, nome: this.PAGE.queixa_dor_lombar, selecionada: false },
      { id: 6, nome: this.PAGE.queixa_falta_ar_esforco, selecionada: false },
      { id: 7, nome: this.PAGE.queixa_falta_ar_repouso, selecionada: false },
      { id: 8, nome: this.PAGE.queixa_palpitacoes, selecionada: false },
      { id: 9, nome: this.PAGE.queixa_dor_joelhos, selecionada: false },
      { id: 10, nome: this.PAGE.queixa_tontura, selecionada: false },
      { id: 11, nome: this.PAGE.queixa_sem_dores, selecionada: false },
    ];
  
    this.doencas = [
      { id: 1, nome: this.PAGE.doenca_diabetes, selecionada: false },
      { id: 2, nome: this.PAGE.doenca_colesterol, selecionada: false },
      { id: 3, nome: this.PAGE.doenca_pressao_alta, selecionada: false },
      { id: 4, nome: this.PAGE.doenca_nao_tem, selecionada: false },
    ];
  
    this.frequencia = [
      { id: 1, nome: '2x', selecionada: false },
      { id: 2, nome: '3x', selecionada: false },
      { id: 3, nome: '4x', selecionada: false },
      { id: 4, nome: '5x', selecionada: false },
      { id: 5, nome: '6x', selecionada: false },
      { id: 6, nome: '7x', selecionada: false },
    ];
  
    this.favoritos = [
      { id: 1, nome: this.PAGE.fav_serie_trad, selecionada: false },
      { id: 2, nome: this.PAGE.fav_serie_circ, selecionada: false },
      { id: 3, nome: this.PAGE.fav_peso_corpo, selecionada: false },
      { id: 4, nome: this.PAGE.fav_peso_cardio, selecionada: false },
    ];
  }

}
